// src/components/SendNewsletter.js
import React, { useState, useRef } from 'react';
import './SendNewsletter.css';

const SendNewsletter = () => {
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [image, setImage] = useState(null);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    // Ref to access the file input
    const fileInputRef = useRef(null);

    const handleSendNewsletter = async (e) => {
        e.preventDefault();
        setSuccessMessage('');
        setErrorMessage('');

        const formData = new FormData();
        formData.append('subject', subject);
        formData.append('message', message);
        if (image) {
            formData.append('image', image);
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/send-newsletter`, {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (response.ok) {
                setSuccessMessage('Newsletter sent successfully!');
                setSubject('');
                setMessage('');
                setImage(null);

                // Clear the file input field
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } else {
                setErrorMessage('Failed to send newsletter. Please try again.');
            }
        } catch (error) {
            setErrorMessage('Error sending newsletter.');
        }
    };

    return (
        <div className="newsletter-container">
            <h2>Send Newsletter</h2>
            <form onSubmit={handleSendNewsletter}>
                <input
                    type="text"
                    placeholder="Subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    required
                />
                <textarea
                    placeholder="Message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                    rows="6"
                />
                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                    ref={fileInputRef} // Attach ref to file input
                />
                <button type="submit">Send Newsletter</button>
                {errorMessage && <div className="error-message">{errorMessage}</div>}
                {successMessage && <div className="success-message">{successMessage}</div>}
            </form>
        </div>
    );
};

export default SendNewsletter;
